import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';

import FacebookImage from '../../../assets/appFooterFacebook.png';
import TwitterImage from '../../../assets/appFooterTwitter.png';

import XImage from '../../../assets/X.svg';
import InstagramImage from '../../../assets/instagram.svg';
import TikTokImage from '../../../assets/tiktok.svg';
import en from '../../../data/en.json';

function Copyright() {
  return (
    <React.Fragment>
      <Typography variant='body2' sx={{color: "white"}}>
        {'© '}
        <Link color="primary.main" href="https://mui.com/" sx={{color: "white"}}>
          {en.common.inkBowl}
        </Link>{' '}
        {new Date().getFullYear()}
      </Typography>
    </React.Fragment>
  );
}

const iconStyle = {
  width: { xs: 32, md: 48 }, // Smaller icons on mobile
  height: { xs: 32, md: 48 },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'white',
  mr: { xs: 0.5, md: 1 }, // Less margin on mobile
  '&:hover': {
    bgcolor: 'primary.dark'
  },
};

const LANGUAGES = [
  {
    code: 'en-US',
    name: 'English',
  },
  {
    code: 'es-ES',
    name: 'Español',
  },
];

export default function AppFooter() {
  return (
    <Typography
      component="footer"
      sx={{ 
        display: 'flex', 
        bgcolor: 'primary.dark',
        minHeight: { xs: '10vh', md: 'auto' }
      }}
    >
      <Container sx={{ my: { xs: 4, md: 8 }, pb: { xs: 6, md: 0 }, display: 'flex' }}>
        <Grid container spacing={{ xs: 2, md: 5 }}>
          <Grid item xs={6} sm={4} md={3}>
            <Grid
              container
              direction="column"
              justifyContent="flex-end"
              spacing={2}
              sx={{ height: { xs: 'auto', md: 120 } }}
            >
              <Grid item sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 0.5, md: 0 } }}>
                <Box component="a" href="#" sx={iconStyle}>
                  <img
                    src={XImage}
                    alt="X/Twitter"
                  />
                </Box>
                <Box component="a" href="#" sx={iconStyle}>
                  <img
                    src={InstagramImage}
                    alt="Instagram"
                  />
                </Box>
                <Box component="a" href="#" sx={iconStyle}>
                  <img
                    src={TikTokImage}
                    alt="TikTok"
                  />
                </Box>
              </Grid>
              <Grid item sx={{ display: { xs: 'none', md: 'block' } }}>
                <Copyright />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={0} sm={4} md={2} sx={{ display: { xs: 'none', sm: 'block' } }} />
          <Grid item xs={0} sm={4} md={2} sx={{ display: { xs: 'none', md: 'block' } }} />
          <Grid item xs={6} sm={4} md={2}>
            <Typography variant="h6" marked="left" gutterBottom sx={{color: "white", fontSize: { xs: '1rem', md: '1.25rem' }}}>
              {en.marketing.legal}
            </Typography>
            <Box component="ul" sx={{ m: 0, listStyle: 'none', p: 0 }}>
              <Box component="li" sx={{ py: { xs: 0.25, md: 0.5 } }}>
                <Link href="#" sx={{color: "white", fontSize: { xs: '0.75rem', md: '1rem' }}}>{en.marketing.terms}</Link>
              </Box>
              <Box component="li" sx={{ py: { xs: 0.25, md: 0.5 } }}>
                <Link href="#" sx={{color: "white", fontSize: { xs: '0.75rem', md: '1rem' }}}>{en.marketing.privacy}</Link>
              </Box>
            </Box>
          </Grid>
          
          {/* Mobile Copyright - appears below on its own row */}
          <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' }, textAlign: 'center', mt: 2 }}>
            <Copyright />
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}
